import * as React from 'react';
import Button from '@mui/material/Button';
import { Avatar, Box, Card, CardActions, CardContent, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, FormControlLabel, Grid, InputLabel, MenuItem, Pagination, Select, Snackbar, Stack, Switch, Tab, Table, TableBody, TableCell, TableHead, TableRow, Tabs, TextField, Typography, debounce } from '@mui/material';
import { addUserEffects, approveAccountDeletionRequest, assignUserIdToDeletionRequest, cancelOffer, changeAdsStatusForUser, getAccountDeletionRequests, getBetlistsPaginated, getFullMatchInfo, getFunnelList, getOffers, getPromoBanners, getProviderVarietyInfo, getTemplates, getUserAggregatedInfo, getUsersPaginated, rejectAccountDeletionRequest, updateBetStateForBetlist, updateUserBalance } from '../Api';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import PromoBannerDto from '../models/dtos/PromoBannerDto';
import PromoBannerCard from '../components/PromoBannerCard';
import TemplateDto from '../models/dtos/TemplateDto';
import { DataGrid } from '@mui/x-data-grid/DataGrid/DataGrid';
import { GridColDef } from '@mui/x-data-grid/models/colDef/gridColDef';
import FunnelDto from '../models/dtos/FunnelDto';
import FunnelConfigDto from '../models/dtos/FunnelConfigDto';
import { GridCellParams, GridValueGetterParams } from '@mui/x-data-grid/models/params/gridCellParams';
import { useCallback } from 'react';
import AccountDeletionRequestDto from '../models/dtos/AccountDeletionRequestDto';
import { rowSelectionStateInitializer } from '@mui/x-data-grid/internals';
import AccountMainInfoDto from '../models/dtos/AccountMainInfoDto';
import AggregateUserInfoDto from '../models/dtos/AggregateUserInfoDto';
import BetlistShortDto from '../models/dtos/BetlistShortDto';
import BetlistsTable from '../components/BetlistsTable';
import BalanceTable from '../components/BalanceTable';
import SupportChatTable from '../components/SupportChatTable';
import MatchInfoDto from '../models/dtos/MatchInfoDto';
import MatchVarietyDto from '../models/dtos/MatchVarietyDto';
import MatchAdditionalInfoDto from '../models/dtos/MatchAdditionalInfoDto';
import VarietiesTable from '../components/VarietiesTable';
import BetsForMatchesTable from '../components/BetsForMatchesTable';
import ProviderMatchEventInfoDto from '../models/dtos/ProviderMatchEventInfoDto';
import ProviderMatchEventInfoTables from '../components/ProviderMatchEventInfoTables';


export default function MatchPage() {
    let matchId = useParams()['id'] ?? 'empty';
    let source = useParams()['source'] ?? '0';

    const [state, setState] = React.useState({
        loaded : false,
        info: {} as ProviderMatchEventInfoDto
    });

    const navigate = useNavigate();

    const fetchData = async (matchId: string, source : string) => {
        setState(prevState => ({ ...prevState, loaded: false }));
        let matchInfo = await getProviderVarietyInfo(matchId, source);
        setState(prevState => ({ ...prevState, info: matchInfo ?? { id: matchId } as ProviderMatchEventInfoDto, loaded: matchInfo != null }));
    }

    React.useEffect(() => {
        fetchData(matchId, source);
    }, []);

    return (
        <div>
            <Stack gap="50px 50px" sx={{ mx: 5, my: 5 }} justifyContent='center' alignItems='center'>
                <Grid container spacing={2} columns={{ xs: 1, sm: 2, md: 4, lg: 6 }} alignItems='center'>
                    <Grid item xs={0} sm={1} md={3} lg={5} />
                    <Grid item xs={1} sm={1} md={1} lg={1}>
                        <Button variant="contained" fullWidth={true} style={{ height: '54px' }} onClick={() => navigate('/matches')}>Go to Matches</Button>
                    </Grid>
                    <Box width="100%" />
                    <Box width="100%" />
                    {!state.loaded ?
                        <React.Fragment>
                            <Grid item xs={0} sm={0} md={1} lg={2} />
                            <Grid item xs={1} sm={2} md={2} lg={2} key="progress">
                                <Stack alignContent='center' alignItems="center" direction="row" sx={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <CircularProgress size={64} style={{ marginBottom: '32px' }} /></Stack></Grid>

                        </React.Fragment> : <React.Fragment>
                        <Grid item xs={0} sm={0} md={1} lg={2} />
                            <Grid item lg={6} xs={1} sm={2} md={4}>
                                <ProviderMatchEventInfoTables info={state.info} showLogs />
                            </Grid>
                        </React.Fragment>}
                </Grid>
            </Stack>
        </div >
    );
}
